(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (() => {
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const choice = event.target.closest('[data-card-choice]');
    const card = choice?.closest('[data-color-card]');
    if (!card || !choice.dataset.variantId) return;
    const price = card.querySelector('[data-card-price]');
    const compare = card.querySelector('[data-card-compare]');
    const compareValue = card.querySelector('[data-card-compare-value]');
    const saleLabel = card.querySelector('[data-card-sale-label]');
    if (!price || !compare || !compareValue || !saleLabel) return;
    const form = card.querySelector('[data-product-form]');
    event.preventDefault();
    if (form?.dataset.cartBusy) return;
    const available = choice.dataset.available === 'true';
    const onSale = Boolean(choice.dataset.comparePrice);
    card.querySelectorAll('[data-card-choice]').forEach(link => {
      if (link === choice) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
    card.querySelectorAll('[data-card-product-link]').forEach(link => { link.href = choice.href; });
    price.textContent = choice.dataset.price;
    price.classList.toggle('product-card__price-sale', onSale);
    compare.hidden = !onSale;
    saleLabel.hidden = !onSale;
    compareValue.textContent = choice.dataset.comparePrice;
    const image = card.querySelector('.product-card__media img');
    if (image && choice.dataset.image) {
      image.srcset = choice.dataset.imageSrcset || '';
      image.src = choice.dataset.image;
      image.alt = choice.dataset.alt || '';
      card.querySelectorAll('.product-card__media img').forEach(other => { other.hidden = other !== image; });
      card.querySelector('.product-card__media').classList.remove('product-card__media--dual');
    }
    if (form) {
      form.querySelector('[name="id"]').value = choice.dataset.variantId;
      const button = form.querySelector('[data-card-add]');
      button.disabled = !available;
      button.textContent = available ? button.dataset.availableLabel : button.dataset.soldoutLabel;
      button.classList.toggle('product-card__soldout', !available);
      const message = form.querySelector('[data-cart-message]');
      if (message) message.textContent = '';
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["store-branches"] && !Shopify.designMode) return;
  try {
    (() => {
    const states = new WeakMap();
    function init(root) {
      if (states.has(root)) return states.get(root);
      const cards = [...root.querySelectorAll('[data-branch]')];
      const slides = [...root.querySelectorAll('[data-branch-slide], [data-branch-fallback]')];
      const contact = root.dataset.branchContext === 'contact';
      const state = { cards, slides, contact, selected: null, version: 0 };
      states.set(root, state);
      syncHash(root);
      return state;
    }
    function select(root, handle) {
      const state = states.get(root) || init(root);
      const card = state.cards.find(item => item.dataset.branch === handle) || state.cards[0];
      if (!card) return;
      const selected = card.dataset.branch;
      if (state.selected === selected) return;
      state.selected = selected;
      const version = ++state.version;
      state.cards.forEach(item => {
        const active = item === card;
        item.classList.toggle('is-active', active);
        const link = item.querySelector('[data-branch-select]');
        if (active) link?.setAttribute('aria-current', 'true');
        else link?.removeAttribute('aria-current');
      });
      let next = state.slides.find(item => item.dataset.branchSlide === selected);
      const image = next?.querySelector('img');
      const show = () => {
        if (version !== state.version || !root.isConnected || !next) return;
        state.slides.forEach(slide => {
          const active = slide === next;
          slide.classList.toggle('is-active', active);
          if (active) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');
        });
      };
      if (image) {
        image.loading = 'eager';
        if (image.complete && image.naturalWidth) show();
        else image.decode().then(show).catch(() => {
          next = state.slides.find(item => item.hasAttribute('data-branch-fallback'));
          show();
        });
      } else show();
    }
    function revealImage(root) {
      if (!matchMedia('(max-width: 831px)').matches) return;
      root.querySelector('[data-branch-media]')?.scrollIntoView({ block: 'start', behavior: 'instant' });
    }
    function syncHash(root, reveal = false) {
      const state = states.get(root);
      let handle = '';
      if (state.contact) {
        try { handle = decodeURIComponent(location.hash.slice(1)); } catch {}
      }
      select(root, handle);
      if (state.contact && handle && reveal) revealImage(root);
    }
    function start(scope) {
      if (scope.matches?.('[data-branch-directory]')) init(scope);
      scope.querySelectorAll('[data-branch-directory]').forEach(init);
    }
    document.addEventListener('pointerover', event => {
      if (event.pointerType === 'touch' || !matchMedia('(hover: hover)').matches) return;
      const card = event.target.closest('[data-branch]');
      const root = card?.closest('[data-branch-directory]');
      if (root) select(root, card.dataset.branch);
    });
    document.addEventListener('focusin', event => {
      const card = event.target.closest('[data-branch]');
      const root = card?.closest('[data-branch-directory]');
      if (root) select(root, card.dataset.branch);
    });
    document.addEventListener('click', event => {
      const link = event.target.closest('[data-branch-select]');
      const root = link?.closest('[data-branch-directory]');
      if (!root || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const state = states.get(root) || init(root);
      const handle = link.closest('[data-branch]').dataset.branch;
      if (state.contact || event.pointerType === 'touch' || matchMedia('(hover: none)').matches) {
        event.preventDefault();
        select(root, handle);
        if (state.contact && location.hash !== '#' + handle) history.pushState(null, '', '#' + encodeURIComponent(handle));
        if (event.detail !== 0 || event.pointerType === 'touch') revealImage(root);
      }
    });
    const syncAll = () => document.querySelectorAll('[data-branch-directory]').forEach(root => { init(root); syncHash(root, true); });
    window.addEventListener('hashchange', syncAll);
    window.addEventListener('popstate', syncAll);
    window.addEventListener('load', syncAll, { once: true });
    document.addEventListener('shopify:section:load', event => start(event.target));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(document), { once: true });
    else start(document);
  })();
  } catch(e) { console.error(e); }
})();

})();
